var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudiobookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9093 20H2.6159C1.61495 20 1.02544 19.5834 0.703894 19.2342C-0.0844191 18.3715 -0.00316747 17.1475 0.00893383 17.011L0.00720507 2.67439C0.00720507 0.712248 1.56654 0 2.6159 0H16.9093V3.39701H15.4951V1.41585H2.6159C2.34103 1.42104 1.42133 1.52649 1.42133 2.67439V17.0715C1.40404 17.3343 1.43516 17.9393 1.75152 18.2816C1.94169 18.4856 2.22347 18.5841 2.6159 18.5841H15.4951V12.677H16.9093V20Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55487 17.9488H0.140747V17.2401C0.140747 15.335 1.59117 14.5881 2.56965 14.5501H16.9097V15.966H2.59731C2.37949 15.9798 1.55487 16.1181 1.55487 17.2401V17.9488Z",
    fill: "#343434"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_89_7974",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H18.7639V0H0V20Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_89_7974)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30807 9.43729H5.7222V6.6488H4.30807V9.43729Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89719 9.43729H11.3113V6.6488H9.89719V9.43729Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3498 9.43729H18.7639V6.6488H17.3498V9.43729Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16989 10.5195H7.58401V5.56488H6.16989V10.5195Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7607 10.5195H13.1748V5.56488H11.7607V10.5195Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4862 10.5195H16.9003V5.56488H15.4862V10.5195Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03354 12.3243H9.44766V3.7583H8.03354V12.3243Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6226 12.3243H15.0368V3.7583H13.6226V12.3243Z",
    fill: "#343434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiobookIcon);
export default __webpack_public_path__ + "static/media/audiobookIcon.4b2a09bdd381a35a73921150bb60ede8.svg";
export { ForwardRef as ReactComponent };